export type Brand = 'ZVRNL' | 'VAKNL';
export enum Theme {
	'zvrnl' = 'ZVRNL',
	'vaknl' = 'VAKNL',
}
